module.exports = __webpack_public_path__ + "static/img/01.7b55b76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/medical/01.png
// module id = mEDp
// module chunks = 1